var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding2Line(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.12508 19.7917V5.93751C3.12502 5.72368 3.19076 5.51501 3.31338 5.33984C3.436 5.16466 3.60956 5.03147 3.8105 4.95834L13.8845 1.29584C13.9631 1.2672 14.0476 1.25796 14.1306 1.2689C14.2136 1.27983 14.2928 1.31063 14.3614 1.35867C14.43 1.40672 14.486 1.47059 14.5246 1.54488C14.5633 1.61917 14.5834 1.70168 14.5834 1.78542V6.9448L21.1626 9.13751C21.3701 9.20662 21.5506 9.3393 21.6785 9.51673C21.8063 9.69415 21.8751 9.90734 21.8751 10.126V19.7917H23.9584V21.875H1.04175V19.7917H3.12508ZM5.20841 19.7917H12.5001V4.01563L5.20841 6.66772V19.7917ZM19.7917 19.7917V10.8771L14.5834 9.14063V19.7917H19.7917Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding2Line);
export default __webpack_public_path__ + "static/media/building-2-line.3e33911f.svg";
export { ForwardRef as ReactComponent };